// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum EstimateOperationResult {
  Failure = 0,
  Success = 1,
  GOCRestrictionApplicable = 2,
  EstimateNoLongerCheckedOut = 3,
  CostReviewSaveFailure = 4,
}
